// extracted by mini-css-extract-plugin
export default {"page_header":"PageHeader_page_header__MT1R8","spin":"PageHeader_spin__wFtml"};